module.exports = __webpack_public_path__ + "static/media/transparent_viunga_grey.115cbbf7.png";